export default __webpack_public_path__ + "./images/dj.4e827e9e.png";